import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ReportStore } from './+state/report.store';
import { ReportStatsStore } from './+state/report-stats.store';
import { ReportsStore } from './+state/reports.store';
import { TaskStore } from './+state/task.store';
import { AssociationService } from './service/association.service';
import { ReportService } from './service/report.service';
import { TaskService } from './service/task.service';

export function provideReport(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ReportService,
    TaskService,
    AssociationService,
    ReportsStore,
    ReportStore,
    ReportStatsStore,
    TaskStore,
  ]);
}
